import { MenuDivider, MenuItem } from "@szhsin/react-menu";
import { useState } from "react";
import {
  GetMeetingNewPageQueryQuery,
  MeetingViewMeetingNodeNewPageFragmentFragment,
} from "types/graphql-schema";

import MeetingDropdownMenu from "@apps/meeting-dropdown-menu/meeting-dropdown-menu";
import useUiPreferenceCache from "@apps/use-ui-preference-cache/use-ui-preference-cache";

import MeetingBot from "./meeting-bot";
import ShareNotesDialog from "./share-meeting/share-meeting-notes-dialog";

export enum MeetingViewEnum {
  notes = "Topics",
  summary = "Meeting Recap",
  previousMeetingSummary = "Last Meeting Recap",
}

const MeetingPageHeader = ({
  meetingGroup,
  meeting,
}: {
  meetingGroup: NonNullable<
    NonNullable<GetMeetingNewPageQueryQuery["meeting"]>["meetingGroup"]
  >;
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
}) => {
  const { uiPreferenceCache, saveUiPreference } = useUiPreferenceCache();
  const [isShowingShareNotesDialog, setIsShowingShareNotesDialog] =
    useState(false);

  const handleShareNotesDialog = () => {
    setIsShowingShareNotesDialog(true);
  };

  const handleCloseInvitationDialog = () => {
    setIsShowingShareNotesDialog(false);
  };

  const isMeetingPageFullyExpanded =
    !uiPreferenceCache.leftNavigationSidebarExpanded &&
    !uiPreferenceCache.meetingSidebarExpanded;

  const handleToggleMeetingPageFullyExpanded = () => {
    saveUiPreference({
      leftNavigationSidebarExpanded: isMeetingPageFullyExpanded,
      meetingSidebarExpanded: isMeetingPageFullyExpanded,
    });
  };

  return (
    <div className="flex items-center mr-2 gap-4">
      <MeetingBot meeting={meeting} />

      <MeetingDropdownMenu
        meeting={meeting}
        meetingGroup={meetingGroup}
        size="5"
        onOpenSendNotesDialog={handleShareNotesDialog}
      >
        <>
          <MenuItem
            className={"text-sm"}
            onClick={handleToggleMeetingPageFullyExpanded}
          >
            {isMeetingPageFullyExpanded
              ? "Exit Fullscreen"
              : "Enter Fullscreen"}
          </MenuItem>
          <MenuDivider />
        </>
      </MeetingDropdownMenu>

      {isShowingShareNotesDialog && (
        <ShareNotesDialog
          meeting={meeting}
          onClose={handleCloseInvitationDialog}
          isInviteDialog={false}
        />
      )}
    </div>
  );
};

export default MeetingPageHeader;
